// var getErrorsBySubject = '/api/errorsbook/getErrorsBySubject';
//资源中心
var allgrade = "https://test.rujiaowang.net/api/resource/allgrade"; //获取所有年级列表
var getsubject = "https://test.rujiaowang.net/api/resource/getsubject"; //获取所有科目列表
var getbooklist = "https://test.rujiaowang.net/api/resource/getbooklist"; //获取所有课本列表
var bookchapter = "https://test.rujiaowang.net/api/resource/bookchapter"; //获取所有章节列表
var getresoursetype = "https://test.rujiaowang.net/api/resource/getresoursetype"; //获取所有资源类型
var getformatype = "https://test.rujiaowang.net/api/resource/getformatype"; //获取所有资源格式
var recommendfiles2 = " https://test.rujiaowang.net/api/recommend/recommendfiles2"; //获取年级最新/最热推荐列表
var selresource = "https://test.rujiaowang.net/api/resource/selresource"; //获取所有资源
var fileView = 'https://test.rujiaowang.net/index.php/api/resource/fileview' //文件浏览次数
var fileDown = 'https://test.rujiaowang.net/index.php/api/resource/filedown' //文件下载次数

//组卷
var getErrorsBySubject = 'https://test.rujiaowang.net/api/errorsbook/getErrorsBySubject';
var getGradeSegment = "https://test.rujiaowang.net/api/Label/getGradeSegment" //获取学段
var getSubjectBygsid = "https://test.rujiaowang.net/api/Label/getSubjectBygsid" // 根据学段获取科目
var getPoints = "https://test.rujiaowang.net/api/Label/getPoints" // 根据学段科目获取知识点
var getQuestionType = "https://test.rujiaowang.net/api/question/getQuestionType" //获取当前科目的题目类型
var allgrade = "https://test.rujiaowang.net/api/resource/allgrade"; //获取所有年级列表
var getsubject = "https://test.rujiaowang.net/api/resource/getsubject"; //获取所有科目列表
var getbooklist = "https://test.rujiaowang.net/api/resource/getbooklist"; //获取所有课本列表
var bookchapter = "https://test.rujiaowang.net/api/resource/bookchapter"; //获取所有章节列表
// var getQuesList = "https://test.rujiaowang.net/api/question/getQuesList"; // 获取试题列表
var getPointsQues = "https://test.rujiaowang.net/api/Question/getPointsQues"; // 获取知识点试题列表
var getChaptersQues = "https://test.rujiaowang.net/api/question/getChaptersQues"; // 获取章节试题列表
var GetUserExam = 'https://test.rujiaowang.net/api/exam/exam/GetUserExam'; // 获取指用户完成组卷的列表
var GetByIdExam = 'https://test.rujiaowang.net/api/exam/exam/GetByIdExam'; // 根据试卷id获取试卷详情
var getDownload = 'https://test.rujiaowang.net/api/exam/exam/htmlToWord'; //下载试卷
var saveexam = 'https://test.rujiaowang.net/api/exam/exam/SaveExam' //保存试卷
var finishexam = 'https://test.rujiaowang.net/api/exam/exam/finishExam' //提交试卷
var GetQuestionList = 'https://test.rujiaowang.net/api/collection/GetQuestionList' //查看我的收藏
var GetQuestionById = 'https://test.rujiaowang.net/api/question/GetQuestionById' //获取指定id的试卷详情
var AddQuestion = 'https://test.rujiaowang.net/api/collection/AddQuestion' //增加收藏题
var DelQuestion = 'https://test.rujiaowang.net/api/collection/DelQuestion' //删除收藏题

// 空间
var getuser = 'https://api.rujiaowang.net/index.php/api/all/login'; //获取用户信息
var getNewDynamicList = 'https://api.rujiaowang.net/index.php/netlearn/dynamic/getNewDynamicList'; //获取最新动态
var getSpace = 'https://api.rujiaowang.net/index.php/netlearn/space/getSpace'; //查询空间
var getcollect = 'https://api.rujiaowang.net/netlearn/dynamic/getcollect'; //获取收藏列表
var Praise = 'https://api.rujiaowang.net/netlearn/Dynamic/dynamicLike'; //点赞/取消点赞
var getguestbook = 'https://api.rujiaowang.net/netlearn/dynamic/getguestbook'; //留言板
var collect = 'https://api.rujiaowang.net/netlearn/dynamic/collect'; //收藏/取消收藏
var album = 'https://api.rujiaowang.net/netlearn/dynamic/getalbumlist'; //获取相册列表
var transpondDynamic = 'https://api.rujiaowang.net/netlearn/dynamic/transpondDynamic'; //动态转发
var login = 'https://api.rujiaowang.net/index.php/api/all/login'; //登录asdsad
var userspace = 'https://api.rujiaowang.net/netlearn/space/getUserspace' //查询制定用户的空间
var getDynamiclist = 'https://api.rujiaowang.net/netlearn/dynamic/getDynamicList' //获取说说
var addguestbook = 'https://api.rujiaowang.net/netlearn/dynamic/addguestbook' //发表留言
var delguestbook = 'https://api.rujiaowang.net/netlearn/dynamic/delguestbook' //删除留言
var addComment = 'https://api.rujiaowang.net/netlearn/dynamic/addComment' //添加评论
var getCommentList = 'https://api.rujiaowang.net/netlearn/dynamic/getCommentList' //添加评论列表
var delComment = 'https://api.rujiaowang.net/netlearn/dynamic/delComment' //评论删除
var getSpaceList = 'https://api.rujiaowang.net/netlearn/space/getSpaceList' //今日推荐
var createDynamic = 'https://api.rujiaowang.net/netlearn/dynamic/createDynamic' //动态发表
var delDynamic = 'https://api.rujiaowang.net/netlearn/dynamic/delDynamic' //动态删除
var searchSpaceList = 'https://api.rujiaowang.net/netlearn/space/searchSpaceList' //人人通空间搜索
var getMyFollowSpace = 'https://api.rujiaowang.net/netlearn/space/getMyFollowSpace' //人人通空间搜索
var delalbum = 'https://api.rujiaowang.net/netlearn/Dynamic/delalbum' //相册删除
var delMyFollowSpace = 'https://api.rujiaowang.net/netlearn/space/delMyFollowSpace' //取消关注空间
var addMyFollowSpace = 'https://api.rujiaowang.net/netlearn/space/addMyFollowSpace' //添加关注空间
var createSpace = 'https://api.rujiaowang.net/netlearn/space/createSpace' //创建空间
var getjournal = 'https://api.rujiaowang.net/netlearn/dynamic/getjournallist' //获取日志列表
var updatejournal = 'https://api.rujiaowang.net/netlearn/dynamic/updatejournal' //编辑日志发布
var addjournal = 'https://api.rujiaowang.net/netlearn/dynamic/addjournal' //发布日志
var deljournal = 'https://api.rujiaowang.net/netlearn/dynamic/deljournal' //删除日志
var getDefaultSpaceList = 'https://api.rujiaowang.net/netlearn/space/getDefaultSpaceList' //默认、学校/班级、机构
var createSpace = 'https://api.rujiaowang.net/netlearn/space/createSpace' //创建空间
var getjournal = 'https://api.rujiaowang.net/netlearn/dynamic/getjournallist' //获取日志列表
var dynamicdetail = 'https://api.rujiaowang.net/netlearn/dynamic/journaldetail' //日志详情
var transpondJournal = 'https://api.rujiaowang.net/netlearn/Dynamic/transpondJournal' //转发日志
var journalLike = 'https://api.rujiaowang.net/netlearn/Dynamic/journalLike' //日志点赞
var getSpacefans = 'https://api.rujiaowang.net/netlearn/space/getSpacefans' // 粉丝列表
var tokengetuser = 'https://api.rujiaowang.net/index.php/api/user/getuser' // 根据token获取个人数据
var getAllowSpaceType = 'https://api.rujiaowang.net/netlearn/space/getAllowSpaceType' //获取所能申请的空间
var getMasterClass = 'https://api.rujiaowang.net/api/teacher/get_teacher_class_list' //获取指定用户空间
var getRecordRjw = 'http://47.114.114.56:9002/RecordRjw' //退出空间上报

// 首页
var getsdtclasslog = "https://api.rujiaowang.net/api/classc/getsdtclasslog" //班级信息
var getlogin = 'https://api.rujiaowang.net/index.php/api/all/login' //登录
var get_school_info = 'https://api.rujiaowang.net/api/school/get_school_info' // 根据school_id获取学校信息
var getregister = 'https://api.rujiaowang.net/api/all/reg_type2' //注册
var getvcode = 'https://api.rujiaowang.net/index.php/api/all/get_user_vcode' //验证码
var checkcode = 'https://api.rujiaowang.net/api/all/checkcode' //验证码校验
var getreset = 'https://api.rujiaowang.net/api/all/editpwd' //重置密码
var recommendfiles2 = 'https://test.rujiaowang.net/api/recommend/recommendfiles2' //资源列表
var getMasterclass = 'https://api.rujiaowang.net/api/teacher/get_master_class_list' //获取作为班主任的班级
var getHomework = 'https://test.rujiaowang.net/api/exam/exam/getAssignByClass' // 首页获取作业
var getHometask = 'https://test.rujiaowang.net/api/task/getTaskList' // 首页获取任务
var getRanking = 'https://api.rujiaowang.net/api/classc/get_class_nice_ranking' // 点赞排行
var getClasslog = 'https://api.rujiaowang.net/api/teacher/get_class_log' // 教学轨迹
var getSchool = 'https://api.rujiaowang.net/api/school/get_school_info' // 获取学校
var getSchoolapply = 'https://api.rujiaowang.net/api/apply/add_apply' // 开通学校服务
var getSubject = 'https://api.rujiaowang.net/api/all/get_subject_list' // 获取科目

//作业系统
var getclass = 'https://test.rujiaowang.net/api/exam/exam/getAssignByClass' //作业列表
var getstudentlist = 'https://api.rujiaowang.net/api/classc/get_class_student_list' //获取班级学生列表
var assignWork = 'https://test.rujiaowang.net/api/exam/exam/assignWork' //发布作业
var osstoken = 'https://api.rujiaowang.net/netlearn/Common/album_get_oss_key' //oss令牌
var assignDocWork = 'https://test.rujiaowang.net/api/exam/exam/assignDocWork' //发布文件作业
var getAssignById = 'https://test.rujiaowang.net/api/exam/exam/getAssignById' //作业详情
var getPapersByAssign = 'https://test.rujiaowang.net/api/exam/exam/getPapersByAssign' //学生列表
var getworkcontent = 'https://test.rujiaowang.net/api/exam/exam/getWorkContent' //获取作业
var correctanswer = 'https://test.rujiaowang.net/api/exam/exam/correctAnswer' //教师批改作业
var getSummary = 'https://test.rujiaowang.net/api/exam/exam/getAssignSummary' //获取班级详情信息
var classlist = 'https://api.rujiaowang.net/api/teacher/get_teacher_class_list' //获取老师所在班级

//预习复习
var gettaskinfo = 'https://test.rujiaowang.net/api/task/getTaskInfo' //详情
var assignTask = 'https://test.rujiaowang.net/api/task/assignTask' //发布预习复习

//备课系统
var getLessonList = 'https://test.rujiaowang.net/api/lesson/GetLessonList' //我的备课列表
var getAddlesson = 'https://test.rujiaowang.net/api/lesson/AddLessonItem' //新增备课
var getDel = 'https://test.rujiaowang.net/api/lesson/Del' //删除备课
var getShare = 'https://test.rujiaowang.net/api/lesson/Share' //共享备课
var getSharelist = 'https://test.rujiaowang.net/api/lesson/GetShareLessonList' //查看协同备课
var getLessondetails = 'https://test.rujiaowang.net/api/lesson/GetLessonContent' //获取备课详情--编辑
var getEditLesson = 'https://test.rujiaowang.net/api/lesson/EditLesson' //修改保存--编辑

// 个人中心
var update_avatar = "https://api.rujiaowang.net/api/user/update_avatar" //修改头像
var user_details = "https://api.rujiaowang.net/api/user/user_details" // 根据token获取个人信息
var edit_teacherinfo = "https://api.rujiaowang.net/api/user/edit_teacherinfo" // 个人信息修改
var GetMyMessage = "https://api.rujiaowang.net/api/message/GetMyMessage" // 系统消息
var GetDelMessage = "https://api.rujiaowang.net/api/message/DelMessage" // 系统消息删除
var GetReadMessage = "https://api.rujiaowang.net/api/message/ReadMessage" // 系统消息已读
var Getteacherclass = "https://api.rujiaowang.net/api/teacher/get_teacher_class_list" // 任课班级

// 数据上报
var dataReporting = "http://47.114.114.56:9002/RecordRjw"

export default {
    dataReporting,
    Getteacherclass,
    getSubject,
    GetReadMessage,
    GetDelMessage,
    GetMyMessage,
    getSchoolapply,
    getSchool,
    getEditLesson,
    getLessondetails,
    getSharelist,
    getShare,
    getDel,
    getAddlesson,
    getLessonList,
    getClasslog,
    getRanking,
    getHometask,
    getHomework,
    getMasterclass,
    saveexam,
    finishexam,
    getErrorsBySubject,
    getDownload,
    getvcode,
    checkcode,
    getreset,
    getlogin,
    getregister,
    allgrade,
    getsubject,
    getbooklist,
    bookchapter,
    getresoursetype,
    getformatype,
    recommendfiles2,
    selresource,
    fileView,
    fileDown,
    getGradeSegment,
    getSubjectBygsid,
    getPoints,
    getQuestionType,
    // getQuesList,
    getPointsQues,
    getChaptersQues,
    GetByIdExam,
    GetUserExam,
    GetQuestionList,
    GetQuestionById,
    AddQuestion,
    DelQuestion,
    getuser,
    getNewDynamicList,
    getSpace,
    getcollect,
    login,
    userspace,
    getDynamiclist,
    Praise,
    getguestbook,
    collect,
    album,
    transpondDynamic,
    addguestbook,
    delguestbook,
    addComment,
    getCommentList,
    delComment,
    getSpaceList,
    createDynamic,
    delDynamic,
    delalbum,
    searchSpaceList,
    getMyFollowSpace,
    addMyFollowSpace,
    delMyFollowSpace,
    createSpace,
    getjournal,
    updatejournal,
    addjournal,
    deljournal,
    getDefaultSpaceList,
    dynamicdetail,
    journalLike,
    transpondJournal,
    getAllowSpaceType,
    getMasterClass,
    getSpacefans,
    tokengetuser,
    getRecordRjw,
    getclass,
    getstudentlist,
    assignWork,
    osstoken,
    assignDocWork,
    getAssignById,
    getPapersByAssign,
    getworkcontent,
    update_avatar,
    getuser,
    recommendfiles2,
    correctanswer,
    getSummary,
    gettaskinfo,
    assignTask,
    user_details,
    edit_teacherinfo,
    get_school_info,
    classlist,
    getsdtclasslog
}